import { EMAIL_TEMPLATES_ALL_LOADED } from '../actions/types';

const initialState = {
  loadingAllEmailTemplates: true,
  allEmailTemplates: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case EMAIL_TEMPLATES_ALL_LOADED:
      return {
        ...state,
        loadingAllEmailTemplates: false,
        allEmailTemplates: [...payload]
      };
    default:
      return state;
  }
};
